import React from 'react';
import { Calendario, IconeEditar } from './Icones';
import { Col, Row } from "reactstrap";

export default class CardPredefinicoes extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = () => this.props.onClick(this.props.index)
    
    handleChange = () => {  }

    editarClick = () => this.props.editarClick(this.props.index)
    
    render() {
        return (
            <Col xs={"auto"} onClick={ this.handleClick }>
                <div className={`card-predefinicoes ${this.props.ativo ? "predefinicoes-selecionado" : ""}`}>
                    <Row>
                        <Col xs={"auto"} className="my-auto">
                            <div className="icone-calendario"><Calendario width={20} color={ !this.props.ativo ? '#D8DFEB' : '#00AEB2' }/></div>
                        </Col>

                        <Col xs={"auto"} className="my-auto px-0">
                            <div className="container">
                                <label className="nome">{this.props.nome}</label>
                                { this.props.ativo && <IconeEditar tamanho="sm" disabled={ !this.props.ativo } onClick={ this.editarClick } className="btn-editar"/> }
                                <label className="descricao">{this.props.descricao ? this.props.descricao : '----' }</label>
                            </div>
                        </Col>
                        
                        <Col xs={"auto"} className="my-auto px-0 ml-auto">
                            <div className="radio">
                                <input id={"predefinicao" + this.props.index} name="radio" type="radio" checked={ this.props.ativo } onChange={ this.handleChange }/>
                                <label htmlFor={"predefinicao" + this.props.index} className="radio-label" onClick={ this.handleClick }></label>
                            </div>
                        </Col>

                    </Row>
                    
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/CardPredefinicoes.js